import axios from 'axios';
import router from '../../router';

export default {
    namespaced: true,
    state: {
        title: '',
        orFlag: false,

        districts: [],
        missingDistricts: true,

        language: '',
        alphabet: '',
        outlet: '',
        type: '',
        position: '',
        design: '',
        content: '',
        sector: '',
        audience: '',
        purpose: '',
        method: '',
        arrangement: '',
        dominance: '',

        markers: [],

        loading: false,
    },
    getters: {
        recentMarkers (state) {
            return state.markers.concat().sort((a, b) => {
                return b.DateCreated.localeCompare(a.DateCreated);
            });
        },
    },
    mutations: {
        setTitle (state, payload) {
            state.title = payload.title || '';
        },
        setOrFlag (state, payload) {
            state.orFlag = payload.orFlag;
        },

        setDistricts (state, payload) {
            state.districts = payload.districts;
        },
        setAllDistrict (state, payload) {
            state.allDistricts = payload.allDistricts;
        },
        setMissingDistricts (state, payload) {
            state.missingDistricts = payload.missingDistricts;
        },

        setLanguage (state, payload) {
            state.language = payload.language;
        },
        setAlphabet (state, payload) {
            state.alphabet = payload.alphabet;
        },
        setOutlet (state, payload) {
            state.outlet = payload.outlet;
        },
        setType (state, payload) {
            state.type = payload.type;
        },
        setPosition (state, payload) {
            state.position = payload.position;
        },
        setDesign (state, payload) {
            state.design = payload.design;
        },
        setContent (state, payload) {
            state.content = payload.content;
        },
        setSector (state, payload) {
            state.sector = payload.sector;
        },
        setAudience (state, payload) {
            state.audience = payload.audience;
        },
        setPurpose (state, payload) {
            state.purpose = payload.purpose;
        },
        setFunction (state, payload) {
            state.method = payload.method;
        },
        setArrangement (state, payload) {
            state.arrangement = payload.arrangement;
        },
        setDominance (state, payload) {
            state.dominance = payload.dominance;
        },

        setMarkers (state, payload) {
            state.markers = payload.markers;
        },

        setLoading (state, payload) {
            state.loading = payload.loading;
        },
    },
    actions: {
        initialize ({ commit, dispatch }) {
            Object.keys(router.history.current.query).forEach((param) => {
                if (router.history.current.query[param]) {
                    switch (param) {
                        case 'title':
                            commit('setTitle', {
                                title: router.history.current.query[ param ]
                            });
                            break;
                        case 'or':
                            commit('setOrFlag', {
                                orFlag: router.history.current.query[ param ]
                            });
                            break;
                        case 'missing':
                            commit('setMissingDistricts', {
                                missingDistricts: router.history.current.query[ param ] === 'true'
                            });
                            break;
                        case 'language':
                            commit('setLanguage', {
                                language: router.history.current.query[ param ]
                            });
                            break;
                        case 'alphabet':
                            commit('setAlphabet', {
                                alphabet: router.history.current.query[ param ]
                            });
                            break;
                        case 'outlet':
                            commit('setOutlet', {
                                outlet: router.history.current.query[ param ]
                            });
                            break;
                        case 'type':
                            commit('setType', {
                                type: router.history.current.query[ param ]
                            });
                            break;
                        case 'position':
                            commit('setPosition', {
                                position: router.history.current.query[ param ]
                            });
                            break;
                        case 'design':
                            commit('setDesign', {
                                design: router.history.current.query[ param ]
                            });
                            break;
                        case 'content':
                            commit('setContent', {
                                content: router.history.current.query[ param ]
                            });
                            break;
                        case 'sector':
                            commit('setSector', {
                                sector: router.history.current.query[ param ]
                            });
                            break;
                        case 'audience':
                            commit('setAudience', {
                                audience: router.history.current.query[ param ]
                            });
                            break;
                        case 'purpose':
                            commit('setPurpose', {
                                purpose: router.history.current.query[ param ]
                            });
                            break;
                        case 'method':
                            commit('setFunction', {
                                method: router.history.current.query[ param ]
                            });
                            break;
                        case 'arrangement':
                            commit('setArrangement', {
                                arrangement: router.history.current.query[ param ]
                            });
                            break;
                        case 'dominance':
                            commit('setDominance', {
                                dominance: router.history.current.query[ param ]
                            });
                            break;
                        case 'districts':
                            commit('setDistricts', {
                                districts: router.history.current.query[ param ].split(',')
                            });
                            break;
                    }
                }
            });
            dispatch('updateMarkers');
        },
        updateRoute ({ state }) {
            router.replace({
                query: {
                    title: state.title ? state.title : undefined,
                    or: state.orFlag ? state.orFlag : undefined,
                    missing: state.missingDistricts ? undefined : state.missingDistricts,

                    language: state.language ? state.language : undefined,
                    alphabet: state.alphabet ? state.alphabet : undefined,
                    outlet: state.outlet ? state.outlet : undefined,
                    type: state.type ? state.type : undefined,
                    position: state.position ? state.position : undefined,
                    design: state.design ? state.design : undefined,
                    content: state.content ? state.content : undefined,
                    sector: state.sector ? state.sector : undefined,
                    audience: state.audience ? state.audience : undefined,
                    purpose: state.purpose ? state.purpose : undefined,
                    method: state.method ? state.method : undefined,
                    arrangement: state.arrangement ? state.arrangement : undefined,
                    dominance: state.dominance ? state.dominance : undefined,

                    districts: state.districts.length > 0 ? state.districts.join(',') : undefined,
                }
            });
        },
        updateMarkers ({ state, commit }) {
            const facets = [
                state.language,
                state.alphabet,
                state.outlet,
                state.type,
                state.position,
                state.design,
                state.content,
                state.sector,
                state.audience,
                state.purpose,
                state.method,
                state.arrangement,
                state.dominance,
            ].filter((facet) => facet !== '');
            const url = 'https://map.linguasnapp.uni-hamburg.de/Public/v2/Map/GetMarkers'
                + '/' + facets.join(',') + ','
                + '/' + (state.orFlag ? 'TRUE' : 'FALSE')
                + '/' + state.title
                + '?districts=' + state.districts.join(',')
                + '' + (state.districts.length === 0 ? ',ALL' : '')
                + '' + (state.missingDistricts ? ',NONE' : '');
            commit('setLoading', { loading: true });
            axios.post(url, { cors: true }).then((result) => {
                commit('setMarkers', { markers: result.data.MarkerList });
                commit('setLoading', { loading: false });

                if (window.oms) {
                    window.oms.removeAllMarkers();

                    result.data.MarkerList.forEach((item) => {
                        const marker = new window.google.maps.Marker({
                            position: { lat: item.Latitude, lng: item.Longitude },
                            title: item.Title,
                            photoCode: item.UniqueNo,
                            icon: {
                                url: 'data:image/svg+xml,%3Csvg width="12" height="12" viewBox="-7 -7 14 14" xmlns="http://www.w3.org/2000/svg"%3E%3Cg%3E%3Cpath stroke-width="2" fill="%23027bcb" stroke="%23bbb" d="M 6,0 A 6,6 0 0 0 -6,0 6,6 0 0 0 6,0"%3E%3C/path%3E%3C/g%3E%3C/svg%3E',
                            },
                        });

                        window.oms.addMarker(marker);

                        marker.addListener('click', () => {
                            const contentString =
                                '<div class="photoTitle">'
                                + '<h4>'
                                + item.Title
                                + '</h4>'
                                + '</div>'
                                + '<div style="display: flex">'
                                + '<div class="lds-ellipsis" style="margin: auto">'
                                + '<div></div>'
                                + '<div></div>'
                                + '<div></div>'
                                + '<div></div>'
                                + '</div>'
                                + '</div>';
                            window.infoWindow.setContent(contentString);

                            const base = 'https://map.linguasnapp.uni-hamburg.de';
                            axios.post(base + '/Public/Map/GetPhoto/' + item.UniqueNo).then((response) => {
                                window.infoWindow.setContent(response.data);
                                setTimeout(() => {
                                    let photo = document.getElementById('divPhotoImage');
                                    photo.addEventListener('click', () => {
                                        // console.log(photo);
                                    });
                                }, 0);
                            });
                        });

                        marker.setMap(window.map);
                    });
                }
            });
        },
        setTitle ({ commit, dispatch }, title) {
            commit('setTitle', { title });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setOrFlag ({ commit, dispatch }, orFlag) {
            commit('setOrFlag', { orFlag });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },

        setDistricts ({ commit, dispatch }, districts) {
            commit('setDistricts', { districts });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setAllDistrict ({ commit, dispatch }, allDistricts) {
            commit('setAllDistrict', { allDistricts });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setMissingDistricts ({ commit, dispatch }, missingDistricts) {
            commit('setMissingDistricts', { missingDistricts });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },

        setLanguage ({ commit, dispatch }, language) {
            language = language.filter(facet => facet !== '').join(',');
            commit('setLanguage', { language });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setAlphabet ({ commit, dispatch }, alphabet) {
            alphabet = alphabet.filter(facet => facet !== '').join(',');
            commit('setAlphabet', { alphabet });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setOutlet ({ commit, dispatch }, outlet) {
            outlet = outlet.filter(facet => facet !== '').join(',');
            commit('setOutlet', { outlet });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setType ({ commit, dispatch }, type) {
            type = type.filter(facet => facet !== '').join(',');
            commit('setType', { type });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setPosition ({ commit, dispatch }, position) {
            position = position.filter(facet => facet !== '').join(',');
            commit('setPosition', { position });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setDesign ({ commit, dispatch }, design) {
            design = design.filter(facet => facet !== '').join(',');
            commit('setDesign', { design });
            dispatch('updateMarkers');
        },
        setContent ({ commit, dispatch }, content) {
            content = content.filter(facet => facet !== '').join(',');
            commit('setContent', { content });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setSector ({ commit, dispatch }, sector) {
            sector = sector.filter(facet => facet !== '').join(',');
            commit('setSector', { sector });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setAudience ({ commit, dispatch }, audience) {
            audience = audience.filter(facet => facet !== '').join(',');
            commit('setAudience', { audience });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setPurpose ({ commit, dispatch }, purpose) {
            purpose = purpose.filter(facet => facet !== '').join(',');
            commit('setPurpose', { purpose });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setFunction ({ commit, dispatch }, method) {
            method = method.filter(facet => facet !== '').join(',');
            commit('setFunction', { method });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setArrangement ({ commit, dispatch }, arrangement) {
            arrangement = arrangement.filter(facet => facet !== '').join(',');
            commit('setArrangement', { arrangement });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
        setDominance ({ commit, dispatch }, dominance) {
            dominance = dominance.filter(facet => facet !== '').join(',');
            commit('setDominance', { dominance });
            dispatch('updateMarkers');
            dispatch('updateRoute');
        },
    },
};
